// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgInvite24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M6.39226 4.2002C5.04341 4.2002 3.94995 5.29365 3.94995 6.6425V11.4502H5.44995V6.6425C5.44995 6.37794 5.55898 6.13884 5.73456 5.96769L12.6999 11.938L19.6653 5.96768C19.8409 6.13884 19.95 6.37794 19.95 6.6425V16.2579C19.95 16.7783 19.5281 17.2002 19.0076 17.2002H10.2V18.7002H19.0076C20.3565 18.7002 21.45 17.6067 21.45 16.2579V6.6425C21.45 5.29365 20.3565 4.2002 19.0076 4.2002H6.39226ZM17.6725 5.7002H7.72737L12.6999 9.9624L17.6725 5.7002Z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M0.25 19.2702C0.25 17.7853 1.45376 16.5815 2.93867 16.5815H6.33133C7.81624 16.5815 9.02 17.7853 9.02 19.2702V20.2395C9.02 20.6538 8.68421 20.9895 8.27 20.9895H1C0.585786 20.9895 0.25 20.6538 0.25 20.2395V19.2702ZM2.93867 18.0815C2.28218 18.0815 1.75 18.6137 1.75 19.2702V19.4895H7.52V19.2702C7.52 18.6137 6.98782 18.0815 6.33133 18.0815H2.93867Z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.75 12.75C4.19772 12.75 3.75 13.1977 3.75 13.75C3.75 14.3023 4.19772 14.75 4.75 14.75C5.30228 14.75 5.75 14.3023 5.75 13.75C5.75 13.1977 5.30228 12.75 4.75 12.75ZM2.25 13.75C2.25 12.3693 3.36929 11.25 4.75 11.25C6.13071 11.25 7.25 12.3693 7.25 13.75C7.25 15.1307 6.13071 16.25 4.75 16.25C3.36929 16.25 2.25 15.1307 2.25 13.75Z"
				/>
			</Svg>
		);
	}
);
SvgInvite24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgInvite24;
